import ChartMultiBars from './ChartMultiBars';

export default ChartMultiBars;
